import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { CookieConsentProvider } from "./components/CookieConsentContext";
import CookieBanner from "./components/CookieBanner";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Entertainment from "./components/Entertainment";
import Events from "./components/Events";
import Pricing from "./components/Pricing";
import Gallery from "./components/Gallery";
import VirtualTour from "./components/VirtualTour";
import Location from "./components/Location";
import FinalCTA from "./components/FinalCTA";
import FAQ from "./components/FAQ";
import FloatingButtons from "./components/FloatingButtons";
import DevicePreview from "./components/DevicePreview";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import NotFound from "./pages/NotFound";
import { useCookieConsent } from "./components/CookieConsentContext";
import { Link } from "react-router-dom";

function Footer() {
  const { reopenBanner } = useCookieConsent();
  return (
    <footer className="bg-navy-deep border-t border-gold/8 py-10 px-6 md:px-12 lg:px-20" data-testid="footer">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-6">
        <div className="text-center">
          <div className="font-unbounded text-sm font-bold text-cream tracking-widest uppercase mb-1">
            Pirate <span className="gold-text">Bowling</span> Center
          </div>
          <p className="font-inter text-xs text-cream/25">Hainstraße 4 · 92355 Velburg · Deutschland</p>
        </div>

        <div className="flex items-center gap-5">
          <a href="https://www.instagram.com/pirate_bowling_center/" target="_blank" rel="noopener noreferrer"
            className="text-cream/25 hover:text-gold transition-colors duration-300" aria-label="Instagram" data-testid="footer-instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
          </a>
          <a href="https://www.facebook.com/p/Pirate-Bowling-Center-Velburg-100063452118398/?locale=de_DE" target="_blank" rel="noopener noreferrer"
            className="text-cream/25 hover:text-gold transition-colors duration-300" aria-label="Facebook" data-testid="footer-facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
          </a>
        </div>

        <p className="font-inter text-xs text-cream/15">
          &copy; {new Date().getFullYear()} Pirate Bowling Center Velburg
        </p>
      </div>

      {/* Legal links */}
      <div className="max-w-7xl mx-auto mt-6 pt-6 border-t border-white/5 flex flex-wrap justify-center gap-6">
        <Link to="/impressum" className="font-inter text-xs text-cream/25 hover:text-gold transition-colors duration-300" data-testid="footer-impressum-link">
          Impressum
        </Link>
        <Link to="/datenschutz" className="font-inter text-xs text-cream/25 hover:text-gold transition-colors duration-300" data-testid="footer-datenschutz-link">
          Datenschutz
        </Link>
        <Link to="/agb" className="font-inter text-xs text-cream/25 hover:text-gold transition-colors duration-300" data-testid="footer-agb-link">
          AGBs
        </Link>
        <button
          onClick={reopenBanner}
          className="font-inter text-xs text-cream/25 hover:text-gold transition-colors duration-300"
          data-testid="footer-cookie-settings"
        >
          Cookie-Einstellungen
        </button>
      </div>
    </footer>
  );
}

function MainPage() {
  return (
    <div className="grain">
      <a
        href="#entertainment"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-5 focus:py-3 focus:rounded-full focus:bg-gold focus:text-navy focus:font-space-grotesk focus:text-sm focus:font-bold focus:shadow-lg"
      >
        Zum Hauptinhalt springen
      </a>
      <Navigation />
      <main id="main">
        <Hero />
        <Entertainment />
        <Events />
        <Pricing />
        <VirtualTour />
        <Gallery />
        <Location />
        <FAQ />
        <FinalCTA />
      </main>
      <FloatingButtons />
      <CookieBanner />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <CookieConsentProvider>
      <BrowserRouter>
        <DevicePreview>
          <div className="App">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </DevicePreview>
      </BrowserRouter>
    </CookieConsentProvider>
  );
}

export default App;
